// extracted by css-extract-rspack-plugin
export default {"infoTooltipRoot":"aJyZSLTBUjUotIuH","infoTooltipBody":"KGDF7bBFaoo6soTS"};